export default __webpack_public_path__ + "static/media/Boy1.70ea5a1d.svg";